import { render, staticRenderFns } from "./document-check.vue?vue&type=template&id=cf9b168a&scoped=true"
var script = {}
import style0 from "./document-check.vue?vue&type=style&index=0&id=cf9b168a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9b168a",
  null
  
)

export default component.exports